import { render, staticRenderFns } from "./m_userinfo.vue?vue&type=template&id=a4297f24&scoped=true&"
import script from "./m_userinfo.vue?vue&type=script&lang=js&"
export * from "./m_userinfo.vue?vue&type=script&lang=js&"
import style0 from "./m_userinfo.vue?vue&type=style&index=0&id=a4297f24&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4297f24",
  null
  
)

export default component.exports